var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-image",class:{
    'base-image--round': this.round
  },style:(_vm.style)},[_c('img',{staticClass:"base-image__img",style:({
      objectFit: _vm.fit
    }),attrs:{"src":_vm.innerSrc,"alt":_vm.alt},on:{"load":_vm.handleLoad,"error":_vm.handleError}})])
}
var staticRenderFns = []

export { render, staticRenderFns }